import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {UtilService} from "@app/modules/shared/services/util.service";
import * as _ from "lodash";
import {
  ExplorerService,
  ModalConfig,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import {DynamicComponent} from "@app/data/dashboard/interfaces/dynamic-component.interface";
import {SpeCodeListComponent} from "@dashboard/modules/application-params/specode/components/specode-list/specode-list.component";
import {RoleListComponent} from "@dashboard/modules/management/role/components/role-list/role-list.component";
import {UserListComponent} from "@dashboard/modules/management/user/components/user-list/user-list.component";
import {MaterialListComponent} from "@dashboard/modules/material-management/material/components/material-list/material-list.component";
import {CurrentAccountListComponent} from "@dashboard/modules/finance-management/current-account/components/current-account-list/current-account-list.component";
import {TranslateService} from "@app/modules/shared/services/translate/translate.service";
import {VatRateListComponent} from "@dashboard/modules/application-params/vat-rate/components/vat-rate-list/vat-rate-list.component";
import {SectorListComponent} from "@dashboard/modules/management/sector/components/sector-list/sector-list.component";
import {UnitListComponent} from "@dashboard/modules/material-management/unit/components/unit-list/units-list.component";
import {UnitSetListComponent} from "@dashboard/modules/material-management/unit-set/components/unit-set-list/unit-set-list.component";
import {NumberSchemaListComponent} from "@dashboard/modules/application-params/number-schema/components/number-schema-list/number-schema-list.component";
import {CustomerListComponent} from "@dashboard/modules/shipping-management/customer/components/customer-list/customer-list.component";
import {EmailSettingsComponent} from "@dashboard/modules/management/email/components/email-settings/email-settings.component";
import {VirtualOrderReceiptListComponent} from "@dashboard/modules/shipping-management/virtual-order-receipt/components/virtual-order-receipt-list/virtual-order-receipt-list.component";
import {ProductLicenseListComponent} from "@dashboard/modules/material-management/product-license/components/product-license-list/product-license-list.component";
import {InstallationUserListComponent} from "@dashboard/modules/management/installation-user/components/installation-user-list/installation-user-list.component";
import {EmqGetPasswordFormComponent} from "@dashboard/modules/other-operations/emq-get-password/emq-get-password-form/emq-get-password-form.component";
import {LicenseDocumentsReportComponent} from "@app/modules/dashboard/modules/material-management/reports/license-documents-report/license-documents-report.component";
import {
  LemInfoListComponent
} from "@dashboard/modules/other-operations/lem-info/list/lem-info-list/lem-info-list.component";

export interface MenuInterface {
  title?: string;
  icon?: string;
  component?: any;
  id?: string;
  show?: boolean;
  children?: Array<MenuInterface>;
}

@Component({
  selector: "kl-menu",
  templateUrl: "./kl-menu.component.html",
  styleUrls: ["./kl-menu.component.scss"],
})
export class KlMenuComponent implements OnInit {
  @ViewChild("searchInput", {static: true}) private searchInput: ElementRef;
  @ViewChild("filteredMenuList", {static: true})
  private filteredMenuList: ElementRef;
  @Input() userRole: any;
  structuredMenu: Array<MenuInterface> = [
    {
      title: "material_management",
      icon: "fal fa-folder-open",
      id: "01",
      show: this.utilService.isShow("01"),
      children: [
        {
          title: "definitions",
          id: "01.01",
          show: this.utilService.isShow("01.01"),
          children: [
            {
              id: "01.01.01",
              show: this.utilService.isShow("01.01.01"),
              title: "units",
              component: UnitListComponent,
            },
            {
              id: "01.01.02",
              show: this.utilService.isShow("01.01.02"),
              title: "unit_set",
              component: UnitSetListComponent,
            },
          ],
        },
        {
          id: "01.02",
          show: this.utilService.isShow("01.02"),
          title: "cards",
          children: [
            {
              id: "01.02.01",
              show: this.utilService.isShow("01.02.01"),
              title: "materials",
              component: MaterialListComponent,
            },
            {
              id: "01.02.02",
              show: this.utilService.isShow("01.02.02"),
              title: "licence_keys",
              component: ProductLicenseListComponent,
            },
          ],
        },
        {
          id: "01.04",
          title: "reports",
          // show: this.utilService.isShow('01.04'),
          show: true,
          component: null,
          children: [
            {
              id: "01.04.01",
              title: "license_documents_menu",
              // show: this.utilService.isShow('01.04.01'),
              show: true,
              component: LicenseDocumentsReportComponent,
            },
          ],
        },
      ],
    },
    {
      title: "finance_management",
      icon: "fal fa-landmark",
      id: "02",
      show: this.utilService.isShow("02"),
      children: [
        {
          id: "02.01",
          show: this.utilService.isShow("02.01"),
          title: "cards",
          children: [
            {
              id: "02.01.01",
              show: this.utilService.isShow("02.01.01"),
              title: "current_accounts",
              component: CurrentAccountListComponent,
            },
          ],
        },
      ],
    },
    {
      title: "virtual_shipping_management",
      icon: "fal fa-truck",
      id: "03",
      show: this.utilService.isShow("03"),
      children: [
        {
          id: "03.01",
          show: this.utilService.isShow("03.01"),
          title: "cards",
          children: [
            {
              id: "03.01.01",
              show: this.utilService.isShow("03.01.01"),
              title: "customers",
              component: CustomerListComponent,
            },
          ],
        },
        {
          id: "03.02",
          show: this.utilService.isShow("03.02"),
          title: "movements",
          children: [
            {
              id: "03.02.01",
              show: this.utilService.isShow("03.02.01"),
              title: "virtual_order_receipts",
              component: VirtualOrderReceiptListComponent,
            },
          ],
        },
      ],
    },
    {
      title: "other_operations",
      icon: "fal fa-stream",
      id: "04",
      show: this.utilService.isShow("04"),
      children: [
        {
          id: "04.01",
          show: this.utilService.isShow("04.01"),
          title: "kl_retail_mpos_emq_get_password",
          component: EmqGetPasswordFormComponent,
        },
        {
          id: "04.02",
          show: this.utilService.isShow("04.02"),
          title: "lem_info",
          component: LemInfoListComponent,
        },
      ],
    },
    {
      title: "app_management",
      icon: "fal fa-cog",
      id: "05",
      show: this.utilService.isShow("05"),
      children: [
        {
          id: "05.01",
          show: this.utilService.isShow("05.01"),
          title: "general",
          icon: "",
          children: [
            {
              id: "05.01.01",
              show: this.utilService.isShow("05.01.01"),
              title: "number_schema",
              icon: "",
              component: NumberSchemaListComponent,
            },
            {
              id: "05.01.02",
              show: this.utilService.isShow("05.01.02"),
              title: "special_codes",
              icon: "",
              component: SpeCodeListComponent,
            },
          ],
        },
        {
          id: "05.02",
          show: this.utilService.isShow("05.02"),
          title: "material_management",
          icon: "",
          children: [
            {
              id: "05.02.01",
              show: this.utilService.isShow("05.02.01"),
              title: "vat_rate",
              icon: "",
              component: VatRateListComponent,
            },
          ],
        },
      ],
    },
    {
      title: "it_management",
      icon: "fal fa-building",
      id: "06",
      show: this.utilService.isShowAdmin(),
      children: [
        {
          id: "06.01",
          show: this.utilService.isShowAdmin(),
          title: "general",
          icon: "",
          children: [
            {
              id: "06.01.01",
              show: this.utilService.isShowAdmin(),
              title: "sectors",
              icon: "",
              component: SectorListComponent,
            },
            {
              id: "06.01.02",
              show: this.utilService.isShowAdmin(),
              title: "users",
              icon: "",
              component: UserListComponent,
            },
            {
              id: "06.01.03",
              show: this.utilService.isShowAdmin(),
              title: "user_roles",
              icon: "",
              component: RoleListComponent,
            },
            {
              id: "06.01.04",
              show: this.utilService.isShowAdmin(),
              title: "installation_user",
              icon: "",
              component: InstallationUserListComponent,
            },
            {
              id: "06.01.05",
              show: this.utilService.isShowAdmin(),
              title: "email_settings",
              component: EmailSettingsComponent,
            },
          ],
        },
      ],
    },
  ];
  filteredMenu = [];
  filteredMenu2 = [];
  searchText: string;

  selectionPosition = 0;
  scrollTopPosition = 0;
  scrollBottomPosition = 15;

  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.searchText) {
      if (event.keyCode === 38) {
        if (this.selectionPosition > 0) {
          this.selectionPosition = this.selectionPosition - 1;
          if (this.selectionPosition < this.scrollTopPosition) {
            this.filteredMenuList.nativeElement.scrollTop =
              this.filteredMenuList.nativeElement.scrollTop - 42;
            this.scrollTopPosition = this.scrollTopPosition - 1;
            this.scrollBottomPosition = this.scrollBottomPosition - 1;
          }
        }
        if (this.selectionPosition === 0) {
          this.searchInput.nativeElement.focus();
        }
      }
      if (
        event.keyCode === 40 &&
        this.selectionPosition < this.filteredMenu2.length - 1
      ) {
        this.selectionPosition = this.selectionPosition + 1;
        if (this.selectionPosition > this.scrollBottomPosition) {
          this.filteredMenuList.nativeElement.scrollTop =
            this.filteredMenuList.nativeElement.scrollTop + 42;
          this.scrollTopPosition = this.scrollTopPosition + 1;
          this.scrollBottomPosition = this.scrollBottomPosition + 1;
        }
      }
      if (event.keyCode === 13 && this.filteredMenu[this.selectionPosition]) {
        this.openTab(this.filteredMenu2[this.selectionPosition]);
      }
    }
  }

  constructor(
    private utilService: UtilService,
    private _translate: TranslateService,
    private explorerService: ExplorerService
  ) {
    this.flattenObjectArray(this.structuredMenu);
  }

  ngOnInit() {}

  transform(items: any[], searchText: string, property: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter((item) => {
      return this._translate
        .instant(item[property])
        .toLowerCase()
        .includes(searchText);
    });
  }

  searchInputValueChange(event) {
    this.selectionPosition = 0;
    this.filteredMenu2 = this.transform(this.filteredMenu, event, "title");
  }

  openTab(menuItem) {
    this.searchText = "";
    if (menuItem.modal) {
      const modalConfig = <ModalConfig>{
        title: menuItem.title,
        childTemplate: <DynamicComponent>{
          template: menuItem.component,
          modalId: menuItem.id,
          dataContext: {},
          mode: "list",
          closeInside: menuItem.closeInside,
          isReadOnly: false,
          modalClass: menuItem.class ? menuItem.class : null,
        },
      };
      this.explorerService.openModal(modalConfig);
    } else {
      const tabConfig = <TabConfig>{
        id: menuItem.id,
        icon: menuItem.icon,
        title: menuItem.title,
        isCloseable: true,
        childTemplate: <DynamicComponent>{
          mode: "list",
          tabId: menuItem.id,
          moduleType: menuItem.moduleType ? menuItem.moduleType : "",
          template: menuItem.component,
          dataContext: {},
          service: {},
        },
      };
      this.explorerService.openTab(tabConfig);
    }
  }

  flattenObjectArray(item: any) {
    if (_.isArray(item)) {
      item.map((it) => {
        return this.flattenObjectArray(it);
      });
    } else {
      if (item.hasOwnProperty("children")) {
        return this.flattenObjectArray(item.children);
      } else {
        if (item.show) {
          this.filteredMenu.push(item);
        }
      }
    }
  }
}
